import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
import { faTrash, faPlus, faCheck } from '@fortawesome/free-solid-svg-icons'
import { ConfirmJsMessage } from '../../helpers.js';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { AlertJsMessage, paginationLimit } from './../../helpers.js';
import MileStoneListing from './../assignments/MileStoneListing';
import LoadMoreIcon from './../LoadMoreIcon';
import InfiniteScroll from 'react-infinite-scroll-component';


const MileStonesListing = props => {
	const {
		clientEmail,
        fetchMileStones,
        deleteMileStones,
        updateActionStatus
	} = props;

	const [list, setList] = useState([]);

    const [isFetchRes, setFetchRes] = useState(false);

    const [isLoadMore, setIsLoadMore] = useState(false);

	useEffect(() => {
	   fetchData(0)
	}, [clientEmail])

    const fetchData = (skip) => {
        fetchMileStones({
            clientEmail,
            isCompleted: true,
            skip,
            limit: paginationLimit.TWENTY,
        }).then((res) => {
            const data = Object.values(res);
            let mileStones = data[0]['data']
            const metadata = data[0]['metadata']
            if (skip !== 0) {
                mileStones = [...list, ...mileStones]
            }
            let total = 0;
            if (metadata.length && metadata[0]['total']) {
                total = metadata[0]['total'];
            }
            setFetchRes(true);
            setList(mileStones);
            setIsLoadMore(mileStones.length < total)

        })
    }

    

    const deleteMilestone =  (id) => {
        if (ConfirmJsMessage(`Are you sure you want to delete the milestone?`)) {
            deleteMileStones(id).then(() => {
                setList([])
                setFetchRes(false);
				fetchData(0)
			});
        }
    }

    const updateMilestoneData = (id) => {
        if (ConfirmJsMessage(`Are you sure you want to update the milestone status?`)) {
            updateActionStatus(id, 'milestone', false).then(() => {
                setList([])
                setFetchRes(false);
				fetchData(0)
			});
        }
    }

    const filterList = list;

    return (
        <Fragment>
            <div
					style={{
						marginTop: 25,
					    width: '800px'
					}}
				>
                    <div
							style={{
								overflow: 'auto',
								height: 350
							}}
							id = "scrollableMileStones"
						>
            { (isFetchRes && list.length === 0 ) &&
                                <div style={{ textAlign: 'center', width: '750px' }}>
                                   <h1>No MileStone Available!</h1>
                                </div>
                            }
            <InfiniteScroll
                dataLength={list.length} //This is important field to render the next data
                next={() => fetchData(list.length)}
                hasMore={isLoadMore}
                scrollableTarget="scrollableMileStones"
                loader={
                    <LoadMoreIcon/>
                }
            >
                {filterList.map((l, index) =>  {
                        return (
                            <Fragment>
                                <div  style={{
                                    marginLeft: '2px',
                                }}>
                                    <span
                                            className="link"
                                            style={{ float: 'left', width: '500px', display: 'block',  marginTop: '10px', marginTop: '10px' }}
                                        >{l.title}</span>
                                        <span
                                            className="link"
                                            style={{ float: 'right', marginTop: '10px' }}
                                            onClick={() => deleteMilestone(l._id)}
                                          >
                                            <FontAwesomeIcon icon={faTrash} title={'Delete'}
                                                    style={{ marginRight: 5, color: COLORS.orange }} />
                                            </span>
                                        {/* <span
                                            className="link"
                                            style={{ float: 'right', marginTop: '10px' }}
                                            onClick={() => updateMilestoneData(l._id)}
                                          >
                                            <FontAwesomeIcon  icon={faCheck} title={'Completed'}
                                            style={{ marginRight: 5, color: COLORS.orange }} />
                                        </span> */}
                                </div>
                            </Fragment>
                        )
                })}
            </InfiniteScroll>    
            </div>             
            </div>
         
        </Fragment>
    );
};

export default MileStonesListing;



// WEBPACK FOOTER //
// ./src/components/assignments/MileStoneListing.js